export const CartIcon = ({ color = "#000000" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <rect width="18" height="18" fill="white" />
      <path
        d="M12.75 13.5C11.9175 13.5 11.25 14.1675 11.25 15C11.25 15.3978 11.408 15.7794 11.6893 16.0607C11.9706 16.342 12.3522 16.5 12.75 16.5C13.1478 16.5 13.5294 16.342 13.8107 16.0607C14.092 15.7794 14.25 15.3978 14.25 15C14.25 14.6022 14.092 14.2206 13.8107 13.9393C13.5294 13.658 13.1478 13.5 12.75 13.5ZM0.75 1.5V3H2.25L4.95 8.6925L3.93 10.53C3.8175 10.74 3.75 10.9875 3.75 11.25C3.75 11.6478 3.90804 12.0294 4.18934 12.3107C4.47064 12.592 4.85218 12.75 5.25 12.75H14.25V11.25H5.565C5.51527 11.25 5.46758 11.2302 5.43242 11.1951C5.39725 11.1599 5.3775 11.1122 5.3775 11.0625C5.3775 11.025 5.385 10.995 5.4 10.9725L6.075 9.75H11.6625C12.225 9.75 12.72 9.435 12.975 8.9775L15.66 4.125C15.7125 4.005 15.75 3.8775 15.75 3.75C15.75 3.55109 15.671 3.36032 15.5303 3.21967C15.3897 3.07902 15.1989 3 15 3H3.9075L3.2025 1.5M5.25 13.5C4.4175 13.5 3.75 14.1675 3.75 15C3.75 15.3978 3.90804 15.7794 4.18934 16.0607C4.47064 16.342 4.85218 16.5 5.25 16.5C5.64782 16.5 6.02936 16.342 6.31066 16.0607C6.59196 15.7794 6.75 15.3978 6.75 15C6.75 14.6022 6.59196 14.2206 6.31066 13.9393C6.02936 13.658 5.64782 13.5 5.25 13.5Z"
        fill={color}
      />
    </svg>
  );
};
